var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveCheck1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.333 30.333c.794 0 1.564.094 2.334.21V18.667H9.333V49H31.15c-.513-1.47-.817-3.033-.817-4.667 0-7.723 6.277-14 14-14zm-23.333 0v-3.5c0-.653.513-1.166 1.167-1.166h11.666c.654 0 1.167.513 1.167 1.166v3.5H21zm28-14H7V7h42v9.333zm3.5 23.917L41.417 51.333l-6.417-7 2.707-2.706 3.71 3.71 8.376-8.377 2.707 3.29z",
    fill: "#54DCF2"
  })));
}
export default SvgArchiveCheck1;